







































import Vue from 'vue'
import { createComponent, ref, onMounted, reactive } from '@vue/composition-api'
import CountDown from '@/components/CountDown.vue'
import { formatFileSize, getFileIcon, preTransferHandler, electronDownload } from '@/helpers/common'
import { Message } from 'element-ui'
import { getShareFileInfo, ShareFileInfo, ShareFileItem } from '@/service/common'
import isElectron from 'is-electron'
import { transferThreshold } from '@/constant'
import { useRouter } from '../../hooks/common'
import { checkBeforeDownload } from '@/service/public'
export default createComponent({
    components: {
        CountDown,
    },
    setup(props, setupContext) {
        const router = useRouter()
        const expirationTime = ref('')
        const id = setupContext.root.$route.query.id as string
        const fileInfo = ref<ShareFileInfo>({
            file: {},
        })
        const downloadHandler = async (item: ShareFileItem) => {
            if (isElectron()) {
                console.log('发送请求到客户端')
                const file = {
                    ...item,
                    shareIdentify: fileInfo.value.id,
                }
                electronDownload(file, router, true)
            } else {
                const isContinue = await preTransferHandler({
                    files: item,
                    threshold: transferThreshold,
                    transType: 'download',
                })
                if (isContinue) {
                    const fileId = item.id
                    const res = await checkBeforeDownload(fileId, id)
                    if( res.code === 0 && res.data ) {
                        const link = document.createElement('a')
                        const origin = location.origin
                        link.href = `${origin}/api/downloadAfterCheck?keyword=${res.data}`
                        link.click()
                    }
                }
            }
        }

        onMounted(async () => {
            if (!id) {
                Message.error('分享链接异常，缺少参数')
                return
            }
            const res = await getShareFileInfo({ id })
            if (res.code === 0) {
                fileInfo.value = res.data
                const expireTime = parseInt(
                    ((new Date(res.data.expireTime).getTime() - new Date().getTime()) / 1000).toFixed()
                )
                expirationTime.value = res.data.expireTime
                if (expireTime <= 0) {
                    setupContext.root.$router.push('/linkinvalid')
                }
            } else if (res.code === 1) {
                Message.error(res.desc || '暂无权限')
                setTimeout(() => {
                    setupContext.root.$router.push('/nopermission')
                }, 500)
            } else {
                Message.error(res.desc || '查询文件夹信息失败')
            }
        })
        return {
            formatFileSize,
            getFileIcon,
            expirationTime,
            fileInfo,
            downloadHandler,
        }
    },
})
